import { initTransform } from './constants'

export const createRoomMovement = ({
	translateX = `${initTransform.translateX}px`,
	translateY = `${initTransform.translateY}px`,
	translateZ = `${initTransform.translateZ}px`,
	rotateX = initTransform.rotateX,
	rotateY = initTransform.rotateY,
	rotateZ = initTransform.rotateZ,
}) => {
	return `
		translate3d(${translateX}, ${translateY}, ${translateZ}) 
		rotate3d(1,0,0, ${rotateX}deg) 
		rotate3d(0,1,0, ${rotateY}deg) 
		rotate3d(0,0,1, ${rotateZ}deg)
	`
}

// export const twoAnimationFrames$ = animationFrame$.pipe(
// 	take(2)
// )